export interface PartnerListFilter {
  page?: number | null;
  count?: number | null;
  sort_key?: string | null;
  sort_by?: string | null;
  search?: string | null;
}

export const defaultPartnerListFilter: PartnerListFilter = {
  page: 0,
  count: 10,
  sort_key: '',
  sort_by: '',
  search: '',
};
